import { Button, Card, Form, Input, Typography, App } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import { adminLogin } from "../api/auth";
import { setSession } from "../auth/store";

const BRAND_RED = "#C8102E";

export function LoginPage() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const mutation = useMutation({
    mutationFn: adminLogin,
    onSuccess: (data) => {
      setSession(data.token, { username: data.username, displayName: data.displayName });
      message.success("登录成功");
      navigate("/");
    },
    onError: (err: Error) => {
      message.error(err.message);
    },
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background:
          "radial-gradient(1200px 600px at 50% -10%, rgba(200,16,46,0.10), transparent 60%), #F4F4F5",
      }}
    >
      <Card
        style={{
          width: 380,
          borderRadius: 16,
          border: "1px solid #EEEEEE",
          boxShadow: "0 12px 40px rgba(26,26,26,0.10)",
        }}
        styles={{ body: { padding: 36 } }}
      >
        {/* brand mark */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 28 }}>
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: 14,
              background: BRAND_RED,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: 24,
              boxShadow: "0 6px 18px rgba(200,16,46,0.30)",
            }}
          >
            比
          </div>
          <Typography.Title level={3} style={{ margin: "16px 0 2px", letterSpacing: 1 }}>
            比个价 · 运营后台
          </Typography.Title>
          <Typography.Text type="secondary" style={{ letterSpacing: 2, fontSize: 12 }}>
            GLOW PRICE ADMIN
          </Typography.Text>
        </div>

        <Form
          layout="vertical"
          size="large"
          onFinish={(values) => mutation.mutate(values as { username: string; password: string })}
        >
          <Form.Item name="username" label="用户名" rules={[{ required: true }]}>
            <Input prefix={<UserOutlined style={{ color: "#999" }} />} autoComplete="username" placeholder="请输入用户名" />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true }]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: "#999" }} />}
              autoComplete="current-password"
              placeholder="请输入密码"
            />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={mutation.isPending} block size="large">
            登录
          </Button>
        </Form>

        <Typography.Paragraph
          type="secondary"
          style={{ textAlign: "center", marginTop: 24, marginBottom: 0, fontSize: 12 }}
        >
          © Glow Price · 比个价运营平台
        </Typography.Paragraph>
      </Card>
    </div>
  );
}
